import { Inject, Injectable } from '@angular/core';
import { Invoice } from './models/invoice.model';
import { ApiService } from '../../shared/services/api.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ErrorHandlerService } from '../../shared/services/error-handler.service';
import { API_BASE_URL } from '../../shared/tokens/api.tokens';
import { catchError, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InvoiceService extends ApiService<Invoice> {

  override readonly _baseUrl: string;

  override readonly searchFields: string[] = ['firstName', 'lastName', 'email'];

  constructor(@Inject(API_BASE_URL) apiBaseUrl: string, http: HttpClient, errorHandler: ErrorHandlerService) { 
    super(http, errorHandler);
    this._baseUrl = `${apiBaseUrl}invoices/`;
  }  

  previewInvoices(invoiceDate: Date): Observable<Invoice[]> {
    const params = new HttpParams()
      .set('invoiceDate', invoiceDate.toISOString());
    return this.http.get<Invoice[]>(`${this._baseUrl}preview`, { params }).pipe(
      catchError(this.handleError));    
  }

  generateInvoices(invoiceDate: Date): Observable<Invoice[]> {
    const dto = { invoiceDate: invoiceDate.toISOString() };
    return this.http.post<Invoice[]>(`${this._baseUrl}generate`, dto).pipe(
      catchError(this.handleError)); 
  }

  // Errors are left to the caller so it can show the backend's message (e.g. a missing Listmonk subscriber)
  // instead of the generic toast, and so batch sends can carry on after a failure.
  emailInvoice(invoiceId: number): Observable<Invoice> {
    return this.http.post<Invoice>(`${this._baseUrl}${invoiceId}/email`, {});
  }

  downloadPdf(invoiceId: number) {    
    return this.http.get(`${this._baseUrl}pdf/${invoiceId}`, 
      { 
        responseType: 'blob', 
        observe: 'response' 
      })
      .pipe(catchError(this.handleError)); 
  }
}
